import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthRole } from '../../../features/auth/models/auth-role.enum';
import { SessionService } from '../services/session.service';

export const roleGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const session = inject(SessionService);
  const allowedRoles = route.data['roles'] as AuthRole[] | undefined;

  // Sem roles configuradas, o guard não bloqueia; a rota decide quando aplicar RBAC.
  if (!allowedRoles?.length) {
    return true;
  }

  if (allowedRoles.some((role) => session.hasRole(role))) {
    return true;
  }

  return router.createUrlTree(['/acesso-negado']);
};
